import PropTypes from 'prop-types';
import cn from 'classnames';
import ChallengesAndSolutions from 'UI/components/ChallengesAndSolutions';
import SectionTitle from 'UI/components/SectionTitle';
import Wireframes from 'UI/components/Wireframes';
import Illustration from 'UI/components/Illustration';
import { useChallengesAndSolutionsWithWireframes } from './utils/useChallengesAndSolutionsWithWireframes';
import styles from './styles.module.scss';
import CaseCardsSection from '../CaseCardsSection';

const TwoBlockChallanges = (props) => {
  const {
    type,
    view,
    firstBlock,
    secondBlock,
    images,
    backgroundImageUrl,
  } = useChallengesAndSolutionsWithWireframes(props);

  return (
    <section
      className={
        cn(
          styles[type],
          styles[view],
          styles.container,
          {
            // [styles.challengesWithoutImage]: images?.length,
          },
        )
      }
      // style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {!!images.length && images.map((image) => (
        <Illustration
          src={image.url}
          className={styles.background}
        />
      ))}
      <CaseCardsSection
        section={firstBlock}
        data={firstBlock}
        type={type}
        view={view}
        withSlider
        backgroundImageUrl={backgroundImageUrl}
      />
      {secondBlock && (
        <ChallengesAndSolutions
          data={secondBlock}
          type={type}
          view={view}
        />
      )}
    </section>
  );
};

TwoBlockChallanges.defaultProps = {
  type: '',
};

TwoBlockChallanges.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  type: PropTypes.string,
};

export default TwoBlockChallanges;
